module.exports = __webpack_public_path__ + "static/media/icon_adding_gray.e2970129.png";